import { Button } from '@vfit/shared/atoms';
import { useLoginCard } from './loginCard.hook';
import * as S from './loginCard.styles';
import { ILoginCardProps } from './loginCard.models';
import Link from 'next/link';
const LoginCard = (props: ILoginCardProps) => {
  const { description, title, url } = useLoginCard(props);

  return (
    <S.Card>
      <S.CardContent>
        <S.CardText dangerouslySetInnerHTML={{ __html: title }} />
        <S.CardDescription dangerouslySetInnerHTML={{ __html: description }} />
      </S.CardContent>
      <Link href={url} target="_self">
        <Button model="circle" size="medium" svg="chevronRight" />
      </Link>
    </S.Card>
  );
};

export default LoginCard;
